// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4db8f671","455":"f2dfc5f0","488":"50fda9ab","977":"9126502c"}[chunkId] + ".chunk.js";
};